// extracted by mini-css-extract-plugin
export var container = "container-module--container--NIILZ";
export var content = "container-module--content--Hr9jR";
export var fullWidth = "container-module--fullWidth--eCI7F";